import {
  Download1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { useBangCanDoiPhatSinhCongNoContext } from '../context';
import type { TaiKhoan } from '@/types/schemas';
import { formatDate } from '@/lib/formatUtils';

interface ActionBarProps {
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onPrintClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportDataClick?: () => void;
  onEditPrintTemplateClick?: () => void;
  className?: string;
  searchParams?: MuaHangRecord;
  account?: MuaHangRecord;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onSearchClick,
  onRefreshClick,
  onPrintClick,
  onFixedColumnsClick,
  onExportDataClick,
  onEditPrintTemplateClick,
  className,
  searchParams,
  account
}) => {
  const listAccount = account?.map((item: TaiKhoan) => item.code).join(', ') || 'Tất cả';
  const { canExport, isExporting } = useBangCanDoiPhatSinhCongNoContext();
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Bảng cân đối phát sinh công nợ</h1>
          {searchParams && (searchParams.ngay_ct1 || searchParams.ngay_ct2) && (
            <div className='text-[10px] text-gray-500'>
              <p>
                <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
                {searchParams.ngay_ct1 && searchParams.ngay_ct2 && (
                  <span className='font-semibold'>
                    {account ? `Tài khoản: [${listAccount}], ` : ''}Từ ngày {formatDate(searchParams.ngay_ct1)} đến ngày{' '}
                    {formatDate(searchParams.ngay_ct2)}
                  </span>
                )}
              </p>
            </div>
          )}
        </div>
      }
    >
      {onSearchClick && (
        <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} variant='primary' />
      )}
      {onSearchClick && <ActionButtonV2 icon={PrinterStroke} title='In ấn' onClick={onPrintClick} variant='primary' />}
      {/* No print button */}
      {onRefreshClick && (
        <ActionButtonV2
          icon={RefreshCircle1ClockwiseStroke}
          title='Refresh'
          onClick={onRefreshClick}
          variant='destructive'
        />
      )}
      {onFixedColumnsClick && (
        <ActionButtonV2
          icon={SignPostLeftStroke}
          title='Cố định cột'
          onClick={onFixedColumnsClick}
          variant='secondary'
        />
      )}
      {onExportDataClick && (
        <ActionButtonV2
          icon={Download1Stroke}
          title='Kết xuất dữ liệu'
          onClick={onExportDataClick}
          variant='secondary'
          disabled={!canExport || isExporting}
          loading={isExporting}
          loadingTitle='Đang kết xuất...'
        />
      )}
      <MenuButtonV2
        items={[
          {
            title: 'Chỉnh sửa mẫu in',
            icon: <AritoIcon icon={864} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
